import {useList, useOne} from "@refinedev/core"
import IActivity from "../interfaces/IActivity"
import {useForm} from "@refinedev/antd"

export const ACTIVITY_RESOURCE = 'activity'

export function getActivities() {
    const {data: activitiesData, isLoading: isActivitiesLoading, error: activitiesError} = useList<IActivity>({
        resource: ACTIVITY_RESOURCE,
        meta: {resourceName: 'activities'}
    });
    return {activities: activitiesData?.data ?? [], isActivitiesLoading, activitiesError};
}

export function getActivity(id: string) {
    const {data: activityData, isLoading: isActivityLoading, error: activityError} = useOne<IActivity>({
        resource: ACTIVITY_RESOURCE,
        id: id
    })
    return {activity: activityData?.data, isActivityLoading, activityError}
}

export function createActivity(id?: string) {
    const {formProps, saveButtonProps, formLoading: loadingForm, queryResult: dataActivities} = useForm<IActivity>({
        resource: ACTIVITY_RESOURCE,
        id: id,
    })
    return {formProps, saveButtonProps, loadingForm, activity: dataActivities?.data?.data}
}
